import { inject, injectable } from 'inversify';
import 'reflect-metadata';

import { HttpResponse, IApiGateway, TYPES } from '@desygner/ui-core-api-gateway';

export interface IShareService {
  share(): Promise<HttpResponse>;
}

@injectable()
export class ShareService implements IShareService {
  constructor(@inject(TYPES.ApiGateway) private readonly apiGateway: IApiGateway) {}

  public async share(): Promise<HttpResponse> {
    return await this.apiGateway.use('fluer').fetch('POST', 'business/user-referral/share');
  }
}
